<template>
  <a-modal
      v-if="visible"
      :visible="visible"
      okText="授予"
      title="角色列表"
      width="60%"
      @cancel="handleCancel" @ok="handleOk"
  >
    <a-form layout="inline">
      <a-form-item label="角色名称">
        <a-input v-model="query.roleName" placeholder="请输入角色名称"/>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="customQuery">查询</a-button>
      </a-form-item>
    </a-form>

    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination"
             :row-selection="rowSelection"
             style="margin-top: 24px;"
             @change="handleTableChange">
    </a-table>
  </a-modal>
</template>

<script>
import {deleteRole, queryRoleList} from "@/api/route";
import _ from "lodash";

export default {
  name: "userRoleSelect",
  data() {
    return {
      query: {
        roleName: undefined,
      },
      columns: [
        {
          title: '角色编号',
          dataIndex: 'roleCode',
          key: 'roleCode',
        },
        {
          title: '角色名称',
          dataIndex: 'roleName',
          key: 'roleName',
        },
        {
          title: '描述',
          dataIndex: 'represent',
          key: 'represent',
        },
      ],
      data: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: 0
      },
      loading: true,
      visible: false,
      selectedCode: [],
    }
  },
  methods: {
    async queryRoleList() {
      this.loading = true

      let data = await queryRoleList(this.convertQuery())

      this.convertPagination(data.result)

      this.data = this.convertData(data.result.content)

      this.loading = false
    },
    handleTableChange(pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.query.sort = sorter.field
      this.query.order = sorter.order

      this.queryRoleList()
    },
    async customQuery() {
      this.pagination.current = 1
      await this.queryRoleList()
    },
    convertQuery() {
      return {
        ...this.query,

        pageSize: this.pagination.pageSize,
        pageNo: this.pagination.current,
        sort: this.query.sort,
        order: this.query.order,
      }
    },
    convertPagination(data) {
      this.pagination.current = data.number + 1
      this.pagination.total = data.totalElements
    },
    convertData(data) {
      return _.map(data, (role, index) => {
        return {
          key: role.roleCode,
          ...role,
        }
      })
    },
    toggleVisible() {
      this.visible = !this.visible
      this.queryRoleList()
    },
    handleOk(e) {
      this.$emit('success', this.selectedCode)
      this.visible = false;
    },
    handleCancel(e) {
      this.visible = false;
    },
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedCode = _.map(selectedRows, row => {
            return row.roleCode
          })
        },
        getCheckboxProps: record => ({
          props: {
            disabled: false,
            name: record.name,
          },
        }),
      }
    },
  }
}
</script>

<style scoped>

</style>
